import React from "react";
import { defineMessages, FormattedMessage } from "react-intl";
import classnames from "classnames";
import { WarningIcon } from "../../../theme/assets";
import ServerErrorIcon from "../../../theme/server_error.png";
import "../ErrorScreen.scss";
import styles from "./ServerError.scss";

const msgs = defineMessages({
  title: {
    id: "app.server_error.title",
    description: "Oops! Something went wrong",
    defaultMessage: "Oops! Something went wrong",
  },
  description: {
    id: "app.server_error.description",
    description:
      "Don’t worry, our development team is working on it. Try again later or contatct us if the problem persists",
    defaultMessage:
      "Don’t worry, our development team is working on it. Try again later or contatct us if the problem persists",
  },
  backHome: {
    id: "app.server_error.backHome",
    description: "Back home",
    defaultMessage: "Back home",
  },
});

function ServerError({ hotelSiteURL, handleBackButton }) {
  return (
    <div
      className={classnames(
        "wbkv9-ServerError-wrapper",
        "wbkv9-ErrorScreen-wrapper",
        styles.wrapper
      )}>
      <div
        className={classnames(
          "wbkv9-ServerError-titleContainer",
          "wbkv9-ErrorScreen-titleContainer",
          "wbkv9-ErrorScreen-row",
          styles.titleContainer
        )}>
        <div className={classnames("wbkv9-ServerError-warningIcon", styles.warningIcon)}>
          <WarningIcon />
        </div>

        <div
          className={classnames(
            "wbkv9-ServerError-title",
            "wbkv9-ErrorScreen-title",
            styles.title
          )}>
          <FormattedMessage {...msgs.title} />
        </div>
      </div>

      <div
        className={classnames(
          "wbkv9-ServerError-mainImage",
          "wbkv9-ErrorScreen-mainImage",
          "wbkv9-ErrorScreen-row",
          styles.mainImage
        )}>
        <img src={ServerErrorIcon} />
      </div>

      <div
        className={classnames(
          "wbkv9-ServerError-description",
          "wbkv9-ErrorScreen-description",
          "wbkv9-ErrorScreen-row",
          styles.description
        )}>
        <FormattedMessage {...msgs.description} />
      </div>

      {(hotelSiteURL || (typeof document !== "undefined" && document.referrer)) && (
        <div
          className={classnames(
            "wbkv9-ServerError-backButtonContainer",
            "wbkv9-ErrorScreen-backButtonContainer",
            "wbkv9-ErrorScreen-row",
            styles.backButtonContainer
          )}>
          <button
            className={classnames(
              "wbkv9-ServerError-backButton",
              "wbkv9-ErrorScreen-backButton",
              styles.backButton
            )}
            onClick={handleBackButton}>
            <FormattedMessage {...msgs.backHome} />
          </button>
        </div>
      )}
    </div>
  );
}

export default ServerError;
